/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../config';
import API from '../../../network';

const useRecruiters = (props?: { enabled?: boolean }) => {
  const { enabled } = props || { enabled: true };
  const {
    isLoading, data, error, refetch,
  } = useQuery({
    queryKey: QueryKeys.RECRUITERS,
    queryFn: async () => API.getInstance().getRecruiters().then((response) => response.data),
    refetchOnWindowFocus: false,
    initialData: [],
    enabled,
  });

  const recruitersOptions = React.useMemo(
    () => data?.map((option) => ({ label: option.name, value: option.id })) || [],
    [data],
  );

  const recruitersWithEmailOptions = React.useMemo(
    () => data?.map((option) => ({
      label: option.name,
      subLabel: option.emailAddress,
      value: option.id,
    })) || [],
    [data],
  );

  return {
    recruitersLoading: isLoading,
    recruitersOptions,
    recruitersWithEmailOptions,
    data,
    error,
    fetchRecruiters: refetch,
  };
};

export {
  useRecruiters,
};
